export const customStyle = {
    placeholder: ((style) => ({
        ...style,
        fontSize: "0.75rem",
        fontWeight: "0",
        width: "100%",
        color: "inherit"
    })),
    valueContainer: ((style) => ({
        ...style,
        padding: "0",
        width: "8vw"
    })),
    container: ((style) => ({
        ...style,
        width: "100%",
    })),
    control: ((style) => ({
        ...style,
        borderColor: "#dce4ec",
    }))
}
